export function getCareforceData(): any {
	const careforceData = new URLSearchParams(window.location.search).get("careforceData")
	return careforceData ? careforceData : ""
}

export function getCaseId(): string {
	const careforceData = decodeURIComponent(getCareforceData())
	try {
		return JSON.parse(careforceData).CaseId
	} catch {
		return ""
	}
}

export const getQueryParameters = (url: string): any => {
	try {
		if (!url) return {}
		url = JSON.parse(
			'{"' +
				decodeURI(url.split("?")[1])
					.replace(/"/g, '\\"')
					.replace(/&/g, '","')
					.replace(/=/g, '":"') +
				'"}'
		)
		return url
	} catch {
		return {}
	}
}
export const isValidUrl = (str: string) => {
	var pattern = new RegExp(
		"^((ft|htt)ps?:\\/\\/)?" + // protocol
			"((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name and extension
			"((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
			"(\\:\\d+)?" + // port
			"(\\/[-a-z\\d%@_.~+&:]*)*" + // path
			"(\\?[;&a-z\\d%@_.,~+&:=-]*)?" + // query string
			"(\\#[-a-z\\d_]*)?$",
		"i"
	) // fragment locator
	return pattern.test(str)
}
